export default "__VITE_ASSET__ea738890__"